import type { NetInfoChangeHandler, NetInfoState, NetInfoSubscription } from '@react-native-community/netinfo';

/**
 * Web build: the native NetInfo internals are not available (the package is aliased to a shim), so this mirrors the
 * shim's always-online behavior with the same API as IsolatedNetInfo.ts.
 */
const ONLINE_STATE = { isConnected: true, isInternetReachable: true, type: 'wifi', details: null } as unknown as NetInfoState;

const IsolatedNetInfo = {
  refresh: (): Promise<NetInfoState> => Promise.resolve(ONLINE_STATE),

  addEventListener: (_listener: NetInfoChangeHandler): NetInfoSubscription => () => {},
};

export default IsolatedNetInfo;
